import type { DocumentRecord } from "../../types/record";

interface RagResultCardProps {
  document?: DocumentRecord;
  remainingCount?: number;
  onClick?: () => void;
}

export function RagResultCard({
  document,
  remainingCount,
  onClick,
}: RagResultCardProps) {
  if (remainingCount !== undefined) {
    return (
      <div
        onClick={onClick}
        className="h-32 w-full bg-brand-bg shadow-card rounded-card p-2 overflow-hidden hover:bg-brand-surface transition-colors flex items-center justify-center cursor-pointer"
      >
        <p className="text-sm text-brand-text font-medium">
          +{remainingCount} documents
        </p>
      </div>
    );
  }

  if (!document) return null;

  // Calculate relevance percentage from the score
  const relevancePercentage = Math.min(
    100,
    Math.round((document.score || 0) * 100)
  );

  return (
    <div
      onClick={onClick}
      className="h-32 w-full bg-brand-bg shadow-card rounded-card p-2 overflow-hidden hover:bg-brand-surface transition-colors cursor-pointer"
    >
      <div className="flex flex-col h-full">
        <div className="text-[10px] text-brand-muted text-left">
          Document {document.id}
        </div>
        <div className="flex-1 flex items-center">
          <p className="text-xs text-brand-text font-medium line-clamp-3 text-left w-full">
            {document.title}
          </p>
        </div>
        <div className="flex items-center justify-between">
          <div className="text-[10px] text-brand-muted text-left">Relevance:</div>
          <div className="rounded px-1.5 py-0.5 bg-brand-surface text-[10px] font-medium">
            {relevancePercentage}% match
          </div>
        </div>
      </div>
    </div>
  );
}
